import React from "react";

import { OverflowTooltip, Mid } from "components";
import { Application, TableCellProp } from "types";

const midColumn = () => ({
	Header: "MID",
	accessor: "applicationMID",
	disableSortBy: true,
	Cell: ({ row: { original } }: TableCellProp<Application>) => {
		return (
			<OverflowTooltip onlyOnLaptop title={original?.mid}>
				<Mid merchant={original} />
			</OverflowTooltip>
		);
	},
});

export default midColumn;
